import { useKeycloak } from "@react-keycloak/web";
import {Navigate, useNavigate} from "react-router-dom";
import {useContext, useEffect, useState} from "react";

const RoleAccsess = ({ children }) => {

    const { keycloak } = useKeycloak();

    const isLoggedIn = keycloak.authenticated;
    let roleCoPCheck;
    if(keycloak.tokenParsed != null) {
        roleCoPCheck = keycloak.tokenParsed.realm_access.roles.filter(f => f.match("CoPCheck"));
    }
    if(isLoggedIn && (roleCoPCheck[0] === "CoPCheck")) {
        return isLoggedIn ? children : null;
    } else {
        console.log("Redirecting! You need permission access this page.: " + isLoggedIn);
        return <Navigate to="/"/>;
    }
};

export const useAuthData = () => useContext();

export default RoleAccsess;
